import { createContext } from "react";
import type { Status } from "types/Status";
import useDefinedContext from "hooks/useDefinedContext";

const ChartProfileSelectStatusContext = createContext<Status | undefined>(undefined);
ChartProfileSelectStatusContext.displayName = "ChartProfileSelectStatusContext";

export function useChartProfileSelectStatusContext() {
  return useDefinedContext(ChartProfileSelectStatusContext);
}

export default ChartProfileSelectStatusContext;
